import { Section } from '../components/Section/Section'
import { Metric } from '../components/Metric/Metric'
import { useAnalyticsContext } from '../AnalyticsContext'

export const GrowthAndDiscovery = () => {
  const { period } = useAnalyticsContext()
  return (
    <Section title="Growth & Discovery">
      <Metric
        name="Followers"
        metricName="followers_count"
        period={period}
        tooltip="Total number of followers gained or lost over time"
        showLastSnapshotAsTotal
      />
    </Section>
  )
}
